import { ChevronRight, Sparkles } from 'lucide-react';
import dashboardData from '../../../../../../../data/dashboard/dashboardData.json';

const workspaceUpdates = dashboardData.workspaceUpdates || [];

const UpdatesTab = ({ onOpenUpdatesModal }) => {
  return (
    <div className="flex-1 flex flex-col min-h-0 animate-in fade-in duration-200">
      <div className="shrink-0 flex items-center justify-between gap-2 mb-2 pr-1">
        <p className="text-xs text-slate-500 font-normal">Upgrades on your workspace</p>
        <button
          type="button"
          onClick={() => onOpenUpdatesModal && onOpenUpdatesModal(0)}
          className="text-xs font-semibold text-slate-500 hover:text-primary transition-colors flex items-center gap-1 py-1 whitespace-nowrap cursor-pointer shrink-0"
        >
          <span>View updates</span>
          <ChevronRight size={13} />
        </button>
      </div>

      <div className="flex-1 overflow-y-auto pr-1 space-y-2 min-h-0 my-1">
        {workspaceUpdates.map((update) => (
          <div
            key={update.id}
            onClick={() => onOpenUpdatesModal && onOpenUpdatesModal(update.slideIndex)}
            className={`p-2.5 sm:p-3 rounded-2xl border transition-all cursor-pointer group shadow-2xs hover:shadow-xs ${
              update.theme === 'teal'
                ? 'bg-teal-50/70 border-teal-200/80 hover:border-primary/60'
                : 'bg-slate-50/90 border-slate-200/80 hover:border-primary/50 hover:bg-slate-50'
            }`}
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                {update.icon === 'Sparkles' ? (
                  <div className="w-6 h-6 rounded-lg bg-primary text-white flex items-center justify-center">
                    <Sparkles size={13} className="text-white" />
                  </div>
                ) : (
                  <div className="w-6 h-6 rounded-lg bg-teal-100/80 text-primary flex items-center justify-center font-bold text-xs shadow-2xs">
                    ₹
                  </div>
                )}
                <h4 className="text-xs font-semibold text-slate-800 group-hover:text-primary transition-colors flex items-center gap-1.5">
                  <span>{update.title}</span>
                </h4>
              </div>
              <ChevronRight
                size={14}
                className="text-slate-400 group-hover:text-primary group-hover:translate-x-0.5 transition-all"
              />
            </div>
            <p className="text-[11px] text-slate-500 mt-1 leading-snug font-normal">
              {update.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UpdatesTab;
